import { render, staticRenderFns } from "./BlockInnerCard.vue?vue&type=template&id=7273e456"
import script from "./BlockInnerCard.vue?vue&type=script&lang=js"
export * from "./BlockInnerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports